import Phaser from 'phaser'
import TextureKeys from '../consts/TextureKeys'

export default class BritishFlagProjectile extends Phaser.Physics.Arcade.Sprite {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, TextureKeys.BritainFlag)

    // Scale up the flag by 100% (double its current size)
    this.setScale(0.6, 0.3)
  }

  preUpdate(time: number, delta: number) {
    super.preUpdate(time, delta)

    // Add rotation for visual effect (reduced spin)
    this.angle += 2

    // Allow gravity to affect the flag for a realistic arc
    // (gravity is enabled by default, no need to disable it)
  }
}
